const BOTTOM_GRD_COLOR_NAME = Object.freeze({
  grayLight: '#909090',
  grayDark: '#949494',
  black: '#52545C',
  purpleLight: '#D5A6FF',
  purple: '#D8A6EA',
  purpleDark: '#8827BA',
  greenLight: '#8EDD3D',
  green: '#63BB00',
  blueLight: '#3B83FF',
  blue: '#84ABFF',
  blueMatte: '#5988EA',
  blueNavy: '#003ABA',
  yellow: '#FFEF27',
  orange: '#FF6C02',
  pinkLight: '#B665FF',
  red: '#FF6A7D',
  redDeep: '#DF0D70',
  redDark: '#D20165',
  defaultGreen: '#57C895', // Holiday
  defaultPurple: '#CD6FFF', // Meeting with Slick
});

export default BOTTOM_GRD_COLOR_NAME;
